const NotamIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2521_83588)">
        <circle
          cx="12"
          cy="12"
          r="11.5"
          fill="#E6BB07"
          fillOpacity="0.3"
          stroke="#E6BB07"
        />
        <path
          d="M11.5058 6.17516C11.6785 6.07924 11.7648 6.03128 11.8562 6.01248C11.9371 5.99584 12.0206 5.99584 12.1015 6.01248C12.1929 6.03128 12.2793 6.07924 12.4519 6.17516L16.9568 8.67785C17.1391 8.77915 17.2303 8.8298 17.2966 8.90184C17.3554 8.96557 17.3998 9.04111 17.427 9.1234C17.4577 9.21642 17.4577 9.32071 17.4577 9.5293V14.4707C17.4577 14.6793 17.4577 14.7836 17.427 14.8766C17.3998 14.9589 17.3554 15.0344 17.2966 15.0982C17.2303 15.1702 17.1391 15.2208 16.9568 15.3221L12.4519 17.8248C12.2793 17.9208 12.1929 17.9687 12.1015 17.9875C12.0206 18.0042 11.9371 18.0042 11.8562 17.9875C11.7648 17.9687 11.6785 17.9208 11.5058 17.8248L7.001 15.3221C6.81866 15.2208 6.72749 15.1702 6.6611 15.0982C6.60237 15.0344 6.55792 14.9589 6.53073 14.8766C6.5 14.7836 6.5 14.6793 6.5 14.4707V9.5293C6.5 9.32071 6.5 9.21642 6.53073 9.1234C6.55792 9.04111 6.60237 8.96557 6.6611 8.90184C6.72749 8.8298 6.81866 8.77915 7.001 8.67785L11.5058 6.17516Z"
          fill="#E6BB07"
        />
        <path
          d="M11.9789 9.56495V12M11.9789 14.4351H11.985M6.5 9.5293V14.4707C6.5 14.6793 6.5 14.7836 6.53073 14.8766C6.55792 14.9589 6.60237 15.0344 6.6611 15.0982C6.72749 15.1702 6.81866 15.2208 7.001 15.3221L11.5058 17.8248C11.6785 17.9208 11.7648 17.9687 11.8562 17.9875C11.9371 18.0042 12.0206 18.0042 12.1015 17.9875C12.1929 17.9687 12.2793 17.9208 12.4519 17.8248L16.9568 15.3221C17.1391 15.2208 17.2303 15.1702 17.2966 15.0982C17.3554 15.0344 17.3998 14.9589 17.427 14.8766C17.4577 14.7836 17.4577 14.6793 17.4577 14.4707V9.5293C17.4577 9.32071 17.4577 9.21642 17.427 9.1234C17.3998 9.04111 17.3554 8.96557 17.2966 8.90184C17.2303 8.8298 17.1391 8.77915 16.9568 8.67785L12.4519 6.17516C12.2793 6.07924 12.1929 6.03128 12.1015 6.01248C12.0206 5.99584 11.9371 5.99584 11.8562 6.01248C11.7648 6.03128 11.6785 6.07924 11.5058 6.17516L7.001 8.67785C6.81866 8.77915 6.72749 8.8298 6.6611 8.90184C6.60237 8.96557 6.55792 9.04111 6.53073 9.1234C6.5 9.21642 6.5 9.32071 6.5 9.5293Z"
          stroke="#272727"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2521_83588">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotamIcon;
